import styled from 'styled-components';

export const Label = styled.label`
  color: #333;
  display: block;
  letter-spacing: .02rem;
  margin-bottom: .2rem;
  user-select: none;
`;
